import classNames from 'classnames';
import { t } from 'ttag';

import TopSellerIcon from '@svg/top-seller.svg';
import { Button } from '@ui/Button';
import {
  Modal,
  ModalProps,
} from '@ui/Modal';
import { Title } from '@ui/Title';

import s from './TopSellerInfoModal.sss';

export const TopSellerInfoModal: React.FC<ModalProps> = ({
  className,
  onRequestClose,
  ...props
}) => (
  <Modal
    {...props}
    onRequestClose={onRequestClose}
    withClose={true}
    className={classNames(s.modal, className)}
  >
    <TopSellerIcon
      className={s.icon}
      width="72"
      height="72"
    />
    <Title
      type="h3"
      bold={false}
      className={s.title}
    >
      {t`Супер-продавець`}
    </Title>

    <p className={s.description}>
      {t`Супер-продавці мають високі оцінки від покупців про відмінний сервіс,
      швидкість відправки та гарантують успішну покупку на Шафі`}
    </p>

    <Button
      className={s.button}
      onClick={onRequestClose}
    >
      {t`Добре`}
    </Button>
  </Modal>
);
